import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsCasService } from './edit-dialogs-cas.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-cas',
  templateUrl: './edit-dialogs-cas.component.html',
  styleUrls: ['./edit-dialogs-cas.component.scss']
})
export class EditDialogsCasComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%', height: '150%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsCasService: EditDialogsCasService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsCasComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsCasService.build(); }

  ngOnInit() {
    this.editDialogsCasService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Cas
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsCasService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del ca está ausente
      // -1: El número del ca ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorCas('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorCas('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog cas
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let ca = this.editDialogsCasService.cas;
    let original = this.editDialogsCasService.originalCas;
    return this.editDialogsCasService.compare(ca, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorCas(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
